import { DatePipe } from '@angular/common';
import { format, parse } from 'date-fns';

interface IDateConfig {
  dateStr?: string;
  parseFormat?: string;
  convertToLocalTimeZone?: boolean;
}
export class DateConfig implements IDateConfig{
  dateStr: string | undefined;
  parseFormat?: string = 'dd/MM/yyyy';
  convertToLocalTimeZone?: boolean = false;

  constructor();
  constructor(obj: IDateConfig);
  constructor(obj?: IDateConfig) {

    this.dateStr = obj?.dateStr ?? '';
    this.parseFormat = obj?.parseFormat ?? 'dd/MM/yyyy';
    this.convertToLocalTimeZone = obj?.convertToLocalTimeZone ?? false;
  }
}

export function DateFormat(dateConfig: DateConfig): string {
  if(!dateConfig.dateStr){
    return '';
  }

  let date = new Date(dateConfig.dateStr);

  return format(date, dateConfig.parseFormat ?? 'dd/MM/yyyy');

}

export function DateFormat_LocaleDateString(dateConfig: DateConfig): string {
  if(!dateConfig.dateStr){
    return '';
  }
  const format = dateConfig.parseFormat;
  const date = new Date(dateConfig.dateStr);
  const currentDate = new Date();

  if (isNaN(date.getTime())) {
      return currentDate.toLocaleDateString();
  }

  const datePipe = new DatePipe('el-GR');

  if (dateConfig.convertToLocalTimeZone){
    const formattedDate = format ? datePipe.transform(date, format) : date.toLocaleDateString();
    return formattedDate ?? currentDate.toLocaleDateString();
  }

  const formattedDate = format ? datePipe.transform(date, format) : date.toLocaleDateString('el-GR');
  return formattedDate ?? currentDate.toDateString();
}

export function DateFormat_with_dateParse(dateConfig: DateConfig): string {
  if(!dateConfig.dateStr){
    return '';
  }
  const format = dateConfig.parseFormat;
  const date = dateConfig.dateStr ? dateParse(dateConfig.dateStr, format ?? 'dd/MM/yyyy'):new Date();
  const datePipe = new DatePipe('en-US');

  if (dateConfig.convertToLocalTimeZone){
    const formattedDate = format ? datePipe.transform(date, format) : date.toLocaleDateString();
    return formattedDate ?? "01/01/1990";
  }

  const formattedDate = format ? datePipe.transform(date, format) : date.toLocaleDateString('en-US');

  return formattedDate ?? "01/01/1990";
}

function dateParse(obj:string, ParseFormat: string):Date{
    let formatLowerCase= ParseFormat.toLowerCase();
    let formatItems=formatLowerCase.split("/");
    let dateItems=obj.split("/").map(x=>parseInt(x));
    let monthIndex=formatItems.indexOf("mm");
    let dayIndex=formatItems.indexOf("dd");
    let yearIndex=formatItems.indexOf("yyyy");
    return new Date(dateItems[yearIndex],dateItems[monthIndex]-1,dateItems[dayIndex]);
}
